/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    ControlActivitiesEstimationParams,
    ControlActivitiesEstimationResponse,
    CreatableTestingControlBody,
    TestingControlBulkCreateResponse,
    TestingControlDto,
    TestingControlId,
    TestingControlMockupView,
    UpdatableTestingControl,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getTestingControlsTestingControlId = (
    testingControlId: TestingControlId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TestingControlDto>> => {
    return axios.get(`/api/testing-controls/${testingControlId}`, options);
};

export const getGetTestingControlsTestingControlIdQueryKey = (
    testingControlId: TestingControlId
) => {
    return [`/api/testing-controls/${testingControlId}`] as const;
};

export const getGetTestingControlsTestingControlIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
    TError = AxiosError<null>,
>(
    testingControlId: TestingControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetTestingControlsTestingControlIdQueryKey(testingControlId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingControlsTestingControlId>>
    > = ({ signal }) =>
        getTestingControlsTestingControlId(testingControlId, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: testingControlId !== null && testingControlId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingControlsTestingControlIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTestingControlsTestingControlId>>
>;
export type GetTestingControlsTestingControlIdQueryError = AxiosError<null>;

export function useGetTestingControlsTestingControlId<
    TData = Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
    TError = AxiosError<null>,
>(
    testingControlId: TestingControlId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getTestingControlsTestingControlId>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getTestingControlsTestingControlId>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingControlsTestingControlId<
    TData = Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
    TError = AxiosError<null>,
>(
    testingControlId: TestingControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getTestingControlsTestingControlId>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getTestingControlsTestingControlId>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingControlsTestingControlId<
    TData = Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
    TError = AxiosError<null>,
>(
    testingControlId: TestingControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingControlsTestingControlId<
    TData = Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
    TError = AxiosError<null>,
>(
    testingControlId: TestingControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetTestingControlsTestingControlIdQueryOptions(
        testingControlId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTestingControlsTestingControlIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
    TError = AxiosError<null>,
>(
    testingControlId: TestingControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetTestingControlsTestingControlIdQueryKey(testingControlId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingControlsTestingControlId>>
    > = ({ signal }) =>
        getTestingControlsTestingControlId(testingControlId, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingControlsTestingControlIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTestingControlsTestingControlId>>
>;
export type GetTestingControlsTestingControlIdSuspenseQueryError =
    AxiosError<null>;

export function useGetTestingControlsTestingControlIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
    TError = AxiosError<null>,
>(
    testingControlId: TestingControlId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingControlsTestingControlIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
    TError = AxiosError<null>,
>(
    testingControlId: TestingControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingControlsTestingControlIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
    TError = AxiosError<null>,
>(
    testingControlId: TestingControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingControlsTestingControlIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
    TError = AxiosError<null>,
>(
    testingControlId: TestingControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTestingControlsTestingControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingControlsTestingControlIdSuspenseQueryOptions(
            testingControlId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchTestingControlsTestingControlId = (
    testingControlId: TestingControlId,
    updatableTestingControl: UpdatableTestingControl,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/testing-controls/${testingControlId}`,
        updatableTestingControl,
        options
    );
};

export const getPatchTestingControlsTestingControlIdMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchTestingControlsTestingControlId>>,
        TError,
        { testingControlId: TestingControlId; data: UpdatableTestingControl },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchTestingControlsTestingControlId>>,
    TError,
    { testingControlId: TestingControlId; data: UpdatableTestingControl },
    TContext
> => {
    const mutationKey = ["patchTestingControlsTestingControlId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchTestingControlsTestingControlId>>,
        { testingControlId: TestingControlId; data: UpdatableTestingControl }
    > = (props) => {
        const { testingControlId, data } = props ?? {};

        return patchTestingControlsTestingControlId(
            testingControlId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchTestingControlsTestingControlIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchTestingControlsTestingControlId>>
>;
export type PatchTestingControlsTestingControlIdMutationBody =
    UpdatableTestingControl;
export type PatchTestingControlsTestingControlIdMutationError =
    AxiosError<null>;

export const usePatchTestingControlsTestingControlId = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchTestingControlsTestingControlId>>,
            TError,
            {
                testingControlId: TestingControlId;
                data: UpdatableTestingControl;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchTestingControlsTestingControlId>>,
    TError,
    { testingControlId: TestingControlId; data: UpdatableTestingControl },
    TContext
> => {
    return useMutation(
        getPatchTestingControlsTestingControlIdMutationOptions(options),
        queryClient
    );
};
export const postTestingControls = (
    creatableTestingControlBody: CreatableTestingControlBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TestingControlMockupView>> => {
    return axios.post(
        `/api/testing-controls`,
        creatableTestingControlBody,
        options
    );
};

export const getPostTestingControlsMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postTestingControls>>,
        TError,
        { data: CreatableTestingControlBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postTestingControls>>,
    TError,
    { data: CreatableTestingControlBody },
    TContext
> => {
    const mutationKey = ["postTestingControls"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postTestingControls>>,
        { data: CreatableTestingControlBody }
    > = (props) => {
        const { data } = props ?? {};

        return postTestingControls(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostTestingControlsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postTestingControls>>
>;
export type PostTestingControlsMutationBody = CreatableTestingControlBody;
export type PostTestingControlsMutationError = AxiosError<null>;

export const usePostTestingControls = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postTestingControls>>,
            TError,
            { data: CreatableTestingControlBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postTestingControls>>,
    TError,
    { data: CreatableTestingControlBody },
    TContext
> => {
    return useMutation(
        getPostTestingControlsMutationOptions(options),
        queryClient
    );
};
export const deleteTestingControls = (
    testingControlId: TestingControlId[],
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/testing-controls`, {
        data: testingControlId,
        ...options,
    });
};

export const getDeleteTestingControlsMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTestingControls>>,
        TError,
        { data: TestingControlId[] },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteTestingControls>>,
    TError,
    { data: TestingControlId[] },
    TContext
> => {
    const mutationKey = ["deleteTestingControls"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteTestingControls>>,
        { data: TestingControlId[] }
    > = (props) => {
        const { data } = props ?? {};

        return deleteTestingControls(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTestingControlsMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteTestingControls>>
>;
export type DeleteTestingControlsMutationBody = TestingControlId[];
export type DeleteTestingControlsMutationError = AxiosError<null>;

export const useDeleteTestingControls = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteTestingControls>>,
            TError,
            { data: TestingControlId[] },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteTestingControls>>,
    TError,
    { data: TestingControlId[] },
    TContext
> => {
    return useMutation(
        getDeleteTestingControlsMutationOptions(options),
        queryClient
    );
};
export const postTestingControlsBulk = (
    creatableTestingControlBody: CreatableTestingControlBody[],
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TestingControlBulkCreateResponse>> => {
    return axios.post(
        `/api/testing-controls/bulk`,
        creatableTestingControlBody,
        options
    );
};

export const getPostTestingControlsBulkMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postTestingControlsBulk>>,
        TError,
        { data: CreatableTestingControlBody[] },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postTestingControlsBulk>>,
    TError,
    { data: CreatableTestingControlBody[] },
    TContext
> => {
    const mutationKey = ["postTestingControlsBulk"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postTestingControlsBulk>>,
        { data: CreatableTestingControlBody[] }
    > = (props) => {
        const { data } = props ?? {};

        return postTestingControlsBulk(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostTestingControlsBulkMutationResult = NonNullable<
    Awaited<ReturnType<typeof postTestingControlsBulk>>
>;
export type PostTestingControlsBulkMutationBody = CreatableTestingControlBody[];
export type PostTestingControlsBulkMutationError = AxiosError<null>;

export const usePostTestingControlsBulk = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postTestingControlsBulk>>,
            TError,
            { data: CreatableTestingControlBody[] },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postTestingControlsBulk>>,
    TError,
    { data: CreatableTestingControlBody[] },
    TContext
> => {
    return useMutation(
        getPostTestingControlsBulkMutationOptions(options),
        queryClient
    );
};
export const postTestingControlsControlActivitiesEstimation = (
    controlActivitiesEstimationParams: ControlActivitiesEstimationParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlActivitiesEstimationResponse>> => {
    return axios.post(
        `/api/testing-controls/control-activities-estimation`,
        controlActivitiesEstimationParams,
        options
    );
};

export const getPostTestingControlsControlActivitiesEstimationQueryKey = (
    controlActivitiesEstimationParams?: ControlActivitiesEstimationParams
) => {
    return [
        "POST",
        `/api/testing-controls/control-activities-estimation`,
        controlActivitiesEstimationParams,
    ] as const;
};

export const getPostTestingControlsControlActivitiesEstimationQueryOptions = <
    TData = Awaited<
        ReturnType<typeof postTestingControlsControlActivitiesEstimation>
    >,
    TError = AxiosError<null>,
>(
    controlActivitiesEstimationParams: ControlActivitiesEstimationParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof postTestingControlsControlActivitiesEstimation
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getPostTestingControlsControlActivitiesEstimationQueryKey(
            controlActivitiesEstimationParams
        );

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<typeof postTestingControlsControlActivitiesEstimation>
        >
    > = ({ signal }) =>
        postTestingControlsControlActivitiesEstimation(
            controlActivitiesEstimationParams,
            { signal, ...axiosOptions }
        );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<typeof postTestingControlsControlActivitiesEstimation>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTestingControlsControlActivitiesEstimationQueryResult =
    NonNullable<
        Awaited<
            ReturnType<typeof postTestingControlsControlActivitiesEstimation>
        >
    >;
export type PostTestingControlsControlActivitiesEstimationQueryError =
    AxiosError<null>;

export function usePostTestingControlsControlActivitiesEstimation<
    TData = Awaited<
        ReturnType<typeof postTestingControlsControlActivitiesEstimation>
    >,
    TError = AxiosError<null>,
>(
    controlActivitiesEstimationParams: ControlActivitiesEstimationParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof postTestingControlsControlActivitiesEstimation
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof postTestingControlsControlActivitiesEstimation
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof postTestingControlsControlActivitiesEstimation
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTestingControlsControlActivitiesEstimation<
    TData = Awaited<
        ReturnType<typeof postTestingControlsControlActivitiesEstimation>
    >,
    TError = AxiosError<null>,
>(
    controlActivitiesEstimationParams: ControlActivitiesEstimationParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof postTestingControlsControlActivitiesEstimation
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof postTestingControlsControlActivitiesEstimation
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof postTestingControlsControlActivitiesEstimation
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTestingControlsControlActivitiesEstimation<
    TData = Awaited<
        ReturnType<typeof postTestingControlsControlActivitiesEstimation>
    >,
    TError = AxiosError<null>,
>(
    controlActivitiesEstimationParams: ControlActivitiesEstimationParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof postTestingControlsControlActivitiesEstimation
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function usePostTestingControlsControlActivitiesEstimation<
    TData = Awaited<
        ReturnType<typeof postTestingControlsControlActivitiesEstimation>
    >,
    TError = AxiosError<null>,
>(
    controlActivitiesEstimationParams: ControlActivitiesEstimationParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof postTestingControlsControlActivitiesEstimation
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getPostTestingControlsControlActivitiesEstimationQueryOptions(
            controlActivitiesEstimationParams,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}
